import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { aiAdApi, type WhatsAppSuggestionTargetType } from '../api/aiAds.api';
import WhatsAppUpdateSuggestionsPanel from './WhatsAppUpdateSuggestionsPanel';

export default function AiAdWhatsAppUpdatesForAd({
  targetType,
  targetAdId,
}: {
  targetType: Exclude<WhatsAppSuggestionTargetType, 'UNMATCHED'>;
  targetAdId: number | string;
}) {
  const queryClient = useQueryClient();
  const queryKey = ['ai-ads', 'whatsapp-update-suggestions', targetType, String(targetAdId), 'PENDING'];
  const query = useQuery({
    queryKey,
    queryFn: () => aiAdApi.listWhatsAppUpdateSuggestions({
      status: 'PENDING',
      targetType,
      targetAdId,
      size: 10,
    }),
    refetchInterval: 30000,
  });

  const refresh = () => {
    queryClient.invalidateQueries({ queryKey });
    queryClient.invalidateQueries({ queryKey: ['ai-ads', 'whatsapp-update-suggestions'] });
  };

  const applyMutation = useMutation({
    mutationFn: (id: number) => aiAdApi.applyWhatsAppUpdateSuggestion(id),
    onSuccess: () => {
      toast.success('تم تحديث الإعلان');
      refresh();
    },
    onError: (err: any) => toast.error(err?.response?.data?.message || 'تعذر اعتماد التحديث'),
  });

  const ignoreMutation = useMutation({
    mutationFn: (id: number) => aiAdApi.ignoreWhatsAppUpdateSuggestion(id),
    onSuccess: () => {
      toast.success('تم تجاهل الرد');
      refresh();
    },
    onError: (err: any) => toast.error(err?.response?.data?.message || 'تعذر تجاهل الرد'),
  });

  return (
    <WhatsAppUpdateSuggestionsPanel
      title="رد الذكاء الاصطناعي من واتساب - نحدث أو لا؟"
      emptyText="لا يوجد رد واتساب معلق لهذا الإعلان."
      suggestions={query.data?.content ?? []}
      loading={query.isLoading}
      onRefresh={refresh}
      onApply={(id) => applyMutation.mutate(id)}
      onIgnore={(id) => ignoreMutation.mutate(id)}
      busy={applyMutation.isPending || ignoreMutation.isPending}
    />
  );
}
